/**
 * Whether the signed-in user holds a claim on an organisation.
 *
 * Extracted from the inline `canView` the security route components write by hand, so a page,
 * its sidebar entry and its store all decide with one rule. Deliberately firebase-free and
 * store-free: the store that gates a Firestore read, the route that gates the page and the
 * probes all import the same function, and none of them has to stand up firebase to use it.
 */

/** The shape {@link hasOrgClaim} needs; the real `Organisation` satisfies it. */
export interface ClaimBearingOrg {
  members?: { email?: string; claims?: string[] }[];
}

/** Email comparison is case-insensitive on both sides. */
export function hasOrgClaim(
  org: ClaimBearingOrg | null | undefined,
  userEmail: string | null | undefined,
  claim: string,
): boolean {
  const email = userEmail?.toLowerCase();
  if (!email || !org?.members) return false;
  return org.members.some((member) => member.email?.toLowerCase() === email && !!member.claims?.includes(claim));
}
